<template>
  <div>
    <div class="flex">
      <!-- Order Details -->
      <div class="w-4/6 m-4 p-4 shadow-lg">
        <h1 class="text-gray-800 font-semibold text-xl border-b">
          {{ $t("OrderDetails") }}
        </h1>
        <table class="w-full">
          <thead class="border-b">
            <th class="text-gray-800 font-semibold">Order Id</th>
            <th class="text-gray-800 font-semibold">{{ $t("Amount") }}</th>
            <th class="text-gray-800 font-semibold">{{ $t("Status") }}</th>
            <th class="text-gray-800 font-semibold">{{ $t("User") }}</th>
          </thead>
          <tbody>
            <tr class="border-b p-4">
              <td class="text-center text-gray-900">
                {{ order.order_number }}
              </td>
              <td class="text-center text-gray-900">{{ order.amount }} €</td>
              <td class="text-center text-gray-900">{{ order.status }}</td>
              <td class="text-center text-gray-900">{{ order.user }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /Order Details -->

      <!-- Billing Address -->
      <div class="w-2/6 m-4 p-4 shadow-lg">
        <h1 class="text-gray-800 font-semibold text-xl border-b">
          {{ $t("BillingAddress") }}
        </h1>
        <table v-if="order.billing_address">
          <tbody>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Address1") }}
              </th>
              <td class="pl-6">{{ order.billing_address.address_1 }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Address2") }}
              </th>
              <td class="pl-6">{{ order.billing_address.address_2 }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("City") }}
              </th>
              <td class="pl-6">{{ order.billing_address.city }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("State") }}
              </th>
              <td class="pl-6">{{ order.billing_address.state }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Zip") }}
              </th>
              <td class="pl-6">{{ order.billing_address.zip }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Country") }}
              </th>
              <td class="pl-6">{{ order.billing_address.country }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /Billing Address -->
    </div>

    <div class="flex">
      <!-- Order Items -->
      <div class="w-4/6 m-4 p-4 shadow-lg">
        <h1 class="text-gray-800 font-semibold text-xl border-b">
          {{ $t("Items") }}
        </h1>
        <table class="w-full">
          <thead class="border-b">
            <th class="text-gray-800 font-semibold">{{ $t("Name") }}</th>
            <th class="text-gray-800 font-semibold">{{ $t("Description") }}</th>
            <th class="text-gray-800 font-semibold">{{ $t("Price") }}</th>
          </thead>
          <tbody>
            <tr
              class="border-b"
              v-for="order_items in order.items"
              :key="order_items.id"
            >
              <td class="text-center">{{ order_items.product_name }}</td>
              <td class="text-center">{{ order_items.product_description }}</td>
              <td class="text-center">{{ order_items.price }} €</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /Order Items -->

      <!-- Shipping Address -->
      <div class="w-2/6 m-4 p-4 shadow-lg">
        <h1 class="text-gray-800 font-semibold text-xl border-b">
          {{ $t("ShippingAddress") }}
        </h1>
        <table v-if="order.shipping_address">
          <tbody>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Address1") }}
              </th>
              <td class="pl-6">{{ order.shipping_address.address_1 }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Address2") }}
              </th>
              <td class="pl-6">{{ order.shipping_address.address_2 }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("DeliveryDate") }}
              </th>
              <td class="pl-6">{{ order.shipping_address.delivery_date }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("City") }}
              </th>
              <td class="pl-6">{{ order.shipping_address.city }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("State") }}
              </th>
              <td class="pl-6">{{ order.shipping_address.state }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Zip") }}
              </th>
              <td class="pl-6">{{ order.shipping_address.zip }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">
                {{ $t("Country") }}
              </th>
              <td class="pl-6">{{ order.shipping_address.country }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <!-- /Shipping Address -->
    </div>
    <!-- Payment Details -->
    <!-- <div class="flex">
      <div class="w-2/6 m-4 p-4 shadow-lg">
        <h1 class="text-gray-800 font-semibold text-xl border-b">{{ $t('PaymentDetails')}}</h1>
        <table v-if="order.payment">
          <tbody>
            <tr>
              <th class="font-semibold text-gray-800 text-left">{{ $t('Method')}}</th>
              <td class="pl-6">{{ order.payment.method }}</td>
            </tr>
            <tr>
              <th class="font-semibold text-gray-800 text-left">{{ $t('PaymentStatus')}}</th>
              <td class="pl-6">{{ order.payment.payment_status }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>-->
    <!-- /Payment Details -->

    <div class="py-4">
      <router-link
        to="/profile"
        class="text-white bg-teal-400 px-2 py-1 font-semibold hover:text-teal-400 hover:bg-white rounded shadow-lg"
        >{{ $t("Back") }}</router-link
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      order: [],
      order_number: this.$route.params.order_number,
    };
  },
  created() {
    axios.defaults.headers.common["Authorization"] =
      "Bearer " + localStorage.getItem("access_token");

    axios
      .get(`${process.env.VUE_APP_API}/order/${this.order_number}`)
      .then((response) => {
        this.order = response.data.data;
        // console.log(this.order);
      })
      .catch((error) => console.log(error));
  },
};
</script>

<style></style>
